// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import store from "./store";
import router from "./router";
import './router/permission';

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

// =======================================================================
// ================================  指令  ===============================
// =======================================================================
import Ellipsis from "vue-directive-ellipsis";
import "vue-directive-ellipsis/dist/ellipsis.umd.css";
Vue.directive("ellipsis", Ellipsis);

// 图片预览
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
Vue.use(VueViewer);
VueViewer.setDefaults({
  toolbar: {
    zoomIn: true,
    zoomOut: true,
    oneToOne: false,
    reset: true,
    prev: false,
    play: {
      show: false,
      size: "large"
    },
    next: false,
    rotateLeft: true,
    rotateRight: true,
    flipHorizontal: true,
    flipVertical: true
  },
  url(imageEl) {
    if (imageEl.src.includes(request.baseUrl)) {
      return imageEl.src;
    } else {
      imageEl.src = imageEl.src.replace(
        window.location.origin,
        request.baseUrl
      );
      return imageEl.src;
    }
  }
});

// svg组件  优点可以修改颜色 但UI出图要配合
import "@/components/SvgIcon/index";

// =======================================================================
// ================================  API  ================================
// =======================================================================
import backend from './conf/backend';
import {apiObj} from './conf/api/index';
Vue.prototype.$backend = backend;
Vue.prototype.$api = apiObj;

// =======================================================================
// ===============================  UI组件  ===============================
// =======================================================================
// 引入antd组件
import antdesignvue from "ant-design-vue";
Vue.use(antdesignvue);

// loading组件
import loading from "./components/Loading/index";
Vue.prototype.$loading = loading;

import sTable from './components/Table'
Vue.component('s-table', sTable)

// 引入图片懒加载组件
import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {
  //loading: require('./assets/check_status_2.png'),
  //error: require('./assets/check_status_2.png')
  filter: {
    webp(listener, options) {
      // v-lazy 自动拼接路径
      if (!listener.src) {
        return listener.src;
      } else if (
        listener.src.includes("http") ||
        listener.src.includes("base64")
      ) {
        return listener.src;
      } else {
        listener.src = request.baseUrl + listener.src;
      }
    }
  },
  adapter: {
    loaded(listener, options) {},
    loading(listener, options) {},
    error(listener, options) {}
  }
});
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js